import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';

@Component({
  name: 'ControleEntregaEPIPopup',
  components: {
    TkForm,
  },
})
class ControleEntregaEPIPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: () => {} })
  private readonly presetRow: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(show: boolean) {}
  // #endregion

  // #region [ STORE ]
  private get user() {
    return this.$store.getters.user;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }
  // #endregion

  // #region [ DATA ]
  private internalValue = false;

  private loading = false;

  private vinculos: any[] = null;
  private parcNegocioTodos: any[] = null;

  private row: any = {};

  private defaultRow = {
    __is_new: true,
  };

  private fieldItems = {
    NRVINCULOM: [],
    NMEPI: [],
  };
  // #endregion

  // #region [ COMPUTED ]
  private get genericFilter() {
    const filter = {
      NRORG: this.user.nrorg,
    };

    return filter;
  }

  private get fields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRVINCULOM',
        label: 'Vínculo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRVINCULOM',
        descriptionField: 'NRNMVINCULO',
        items: this.vinculos,
        required: true,
      },
      {
        type: 'empty',
        size: 6,
      },
      {
        name: 'NREPI',
        label: 'EPI',
        size: 6,
        readonly: false,
        type: 'autocomplete',
        valueField: 'NREPI',
        descriptionField: 'NRNMEPI',
        route: 'getEpi',
        reloadOnCreation: true,
        filters: this.genericFilter,
        required: true,
      },
      {
        name: 'QTFORNECIDAEPI',
        label: 'Qtd. Fornecida',
        type: 'number',
        size: 6,
      },
      {
        name: 'NRPARCNEGOCIO',
        label: 'Fornecedor',
        size: 6,
        readonly: false,
        type: 'autocomplete',
        valueField: 'NRPARCNEGOCIO',
        descriptionField: 'NMPRINCIPALPARC',
        route: 'getParcNegocioTodos',
        reloadOnCreation: true,
        filters: this.genericFilter,
        required: false,
      },
      {
        name: 'NRCTRLAPROVEPI',
        label: 'Certificado de Aprovação',
        size: 6,
        type: 'text',
      },
      {
        name: 'DSMODELOEPI',
        label: 'Modelo',
        size: 3,
        type: 'text',
      },
      {
        name: 'IDPROTECAOEFICAZ',
        label: 'Proteção Eficaz',
        size: 3,
        type: 'select',
        valueField: 'IDPROTECAOEFICAZ',
        descriptionField: 'DSPROTECAOEFICAZ',
        items: [
          {IDPROTECAOEFICAZ: 'S', DSPROTECAOEFICAZ: 'Sim' },
          {IDPROTECAOEFICAZ: 'N', DSPROTECAOEFICAZ: 'Não' },
        ],
      },
      {
        name: 'IDCTRLENTREGA',
        label: 'Controle Entrega',
        size: 6,
        type: 'text',
      },
      {
        name: 'DTENTREGAEPI',
        label: 'Entrega Progr.',
        size: 3,
        type: 'date',
      },
      {
        name: 'DTEFETIVA',
        label: 'Entrega Efetiva',
        size: 3,
        type: 'date',
      },
      {
        name: 'NRMOTIVODEVEPI',
        label: 'Motivo Devolução',
        size: 9,
        type: 'select',
        valueField: 'NRMOTIVODEVEPI',
        descriptionField: 'DSMOTIVODEVEPI',
        items: [
          {NRMOTIVODEVEPI: '1', DSMOTIVODEVEPI: '1 | DEMISSÃO OU AFASTAMENTO'},
          {NRMOTIVODEVEPI: '2', DSMOTIVODEVEPI: '2 | EPI SEM CONDIÇÃO DE USO'},
          {NRMOTIVODEVEPI: '3', DSMOTIVODEVEPI: '3 | PRAZO DE VALIDADE EXPIRADO'},
          {NRMOTIVODEVEPI: '4', DSMOTIVODEVEPI: '4 | EXTRAVIO'},
        ]
      },
      {
        name: 'DTDEVOLUCAO',
        label: 'Devolução',
        size: 3,
        type: 'date',
      },
    ];

    return fields;
  }
  // #endregion

  //#region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.row = Util.deepCopy(this.presetRow ? this.presetRow : this.defaultRow);

      if (this.vinculos === null) {
        this.reloadVinculos();
      }
    }
  }

  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.vinculos = null;
  }
  //#endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.row = {};
    this.emitInput(this.internalValue);
  }

  private verifyRequiredFields(): boolean {
    const isValid = this.row.__is_valid;

    if (isValid) {
      return true;
    }

    const message = 'Favor preencher todos os campos obrigatórios!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

    return false;
  }

  private async save() {
    if (!this.verifyRequiredFields()) {
      return;
    }

    const route = 'setHistoricoEpi';

    const params = {
      requestType: 'Row',
      row: {
        NRORG: this.user.nrorg,
        ...this.row,
      },
    };

    this.loading = true;

    try {
      const response = await HttpRequest.post(route, params, false);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      if (response.data.messages) {
        throw new Error(response.data.messages[0].message);
      }

      const success = response.data.dataset.data.success;

      const message = 'Histórico adicionado com sucesso!';
      SnackbarUtils.showMessage(message, 'success', 5000);

      this.closeDialog();
      this.emitAfterSave();
    } catch (err) {
      const errorMessage = 'Não foi possível criar o Histórico.';
      SnackbarUtils.showMessage(errorMessage, 'error', 5000);

      throw err;
    } finally {
      this.loading = false;
    }
  }

  private async reloadVinculos() {
    const vinculos = await CommonRequests.getVinculosDoGestor();
    this.vinculos = vinculos;
  }
  // #endregion
}

export default ControleEntregaEPIPopup;